export const safeDecodeURI = (value: string) => {
  try {
    return decodeURI(value);
  } catch {
    return value.replaceAll(/(?:%[0-9a-fA-F]{2})+/g, (encodedValue) => {
      try {
        return decodeURI(encodedValue);
      } catch {
        return encodedValue;
      }
    });
  }
};

export const safeDecodeURIComponent = (value: string) => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value.replaceAll(/(?:%[0-9a-fA-F]{2})+/g, (encodedValue) => {
      try {
        return decodeURIComponent(encodedValue);
      } catch {
        return encodedValue;
      }
    });
  }
};
